export default __webpack_public_path__ + "static/media/telegram_2.3f0dc33a.png";